


import logo1 from '../images/partner/partner-1.png'
import logo2 from '../images/partner/partner-2.png'
import logo3 from '../images/partner/partner-3.png'
import logo4 from '../images/partner/partner-4.png'
import logo5 from '../images/partner/partner-5.png'
import logo6 from '../images/partner/partner-6.png'
import logo7 from '../images/partner/partner-7.png'
import logo8 from '../images/partner/partner-8.png'
import logo9 from '../images/partner/partner-9.png'
import logo10 from '../images/partner/partner-10.png'
import logo11 from '../images/partner/partner-11.png'
import logo12 from '../images/partner/partner-12.png'
import logo13 from '../images/partner/partner-13.png'
import logo14 from '../images/partner/partner-14.png'
import logo15 from '../images/partner/partner-15.png'
import logo16 from '../images/partner/partner-16.png'
import logo17 from '../images/partner/partner-17.png'
import logo18 from '../images/partner/partner-18.png'


const dataPartner = [
    {
        id: 1,
        img: logo1
    },
    {
        id: 2,
        img: logo2
    },
    {
        id: 3,
        img: logo3
    },

    {
        id: 4,
        img: logo4
    },
    {
        id: 5,
        img: logo5
    },

    {
        id: 6,
        img: logo6
    },
    {
        id: 7,
        img: logo1
    },
    {
        id: 8,
        img: logo8
    },
    {
        id: 9,
        img: logo9
    },
    {
        id: 10,
        img: logo10
    },
    {
        id: 11,
        img: logo11
    },
    {
        id: 12,
        img: logo12
    },
    {
        id: 13,
        img: logo13
    },
    {
        id: 14,
        img: logo14
    },
    {
        id: 15,
        img: logo15
    },
    {
        id: 16,
        img: logo16
    },
    {
        id: 17,
        img: logo17
    },
    {
        id: 18,
        img: logo18
    },


   
]

export default dataPartner;